/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Modal                           from 'react-modal'
import Box                             from "@material-ui/core/Box"
import { Button }                      from '@material-ui/core'
import Grid                            from "@material-ui/core/Grid"
import { node_server }                 from '../Helpers/index.js'
import PropTypes                       from 'prop-types'
import Typography                      from "@material-ui/core/Typography"
import ShowHistoryPhoto                from './ShowHistoryPhoto'

import PilotCohortSourceReadComponent  from './PilotCohortSourceReadComponent.js'

const ModalComponent = ({ closeModal, id }) => {

   const [ displayEntry,  setDisplayEntry  ]  =  useState([])

   /* Fake method to satisfy PropTypes in a child component */
   const handleClick = () => {
      return null
   }

   /* This shows the available Historical Entries from the history collection in MongoDB. */
   useEffect(() => {
      axios.get(node_server + `guestBio/${id}`)
         .then( res => res.data )
         .then( data => {
            const d = data.guestBio

            setDisplayEntry(
               <Modal
                  isOpen={true}
                  ariaHideApp={false}
                  contentLabel="Example Modal"
               >
                  <Grid key={d._id} style={{ marginTop: '2rem' }}>
                     <Typography key={d._id} variant='h5' align='left' style={{ marginBottom: '5px', marginTop: '5px' }} >
                        { d.title }
                     </Typography>

                     {d.tableId && d.tableId === ''
                        ?
                           null
                        :
                           <PilotCohortSourceReadComponent handleClick={handleClick} id={d.tableId} triggerUseEffect={-1} />
                     }

                     {d.entries.length > 0
                        ?
                           d.entries.map( (e, i) => {
                              if (e.entryType === 'text') {
                                 return(
                                    <Typography key={d._id + i} style={{ textAlign: 'left', marginBottom: '10px' }} >
                                       { e.entry }
                                    </Typography>
                                 )
                              }
                              else if(e.entryType === 'bullet') {
                                 return(
                                    <Typography key={d._id + i} style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '20px' }} >
                                       { e.entry }
                                    </Typography>
                                 )
                              }
                              else if(e.entryType === 'photo') {
                                 return(
                                    <Grid key={e._id + i} >
                                       <ShowHistoryPhoto entry={e} />
                                    </Grid>
                                 )
                              }
                              return null
                           } )
                        :
                           null
                     }
                     {d.links.length > 0
                        ?
                           d.links.map( (link, i) => {
                              return(
                                 <Typography key={link._id + i} style={{ textAlign: 'left', marginBottom: '10px' }} >
                                    { link.caption }
                                 </Typography>
                              )
                           })
                        :
                           null
                     }
                  </Grid>
                  <Grid item style={{ marginTop: '1rem' }}>
                     <Button data-testid='guest-bio-modal-submit' variant='contained' color='primary' onClick={closeModal}>Close</Button>
                  </Grid>
               </Modal>
            )
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )

   }, [ id, closeModal ] )

   return (
      <Box>
         <Grid style={{ marginTop: '6rem', padding: '2rem' }} >
            { displayEntry }
         </Grid>
      </Box>
   )
}

ModalComponent.propTypes = {
  closeModal:        PropTypes.func,
  id:                PropTypes.string
}

export default ModalComponent
